/* eslint-disable no-var */
declare var process: { env: Record<string, string | undefined> };

import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';

// Web Firebase config — uses environment variables so credentials are not
// hardcoded. Set these in a .env.local file (see README or docs).
// The projectId, storageBucket, and messagingSenderId are known from the
// project config and can be committed; apiKey and appId should come from env.
const firebaseConfig = {
  apiKey:
    process.env.REACT_APP_FIREBASE_API_KEY ||
    'AIzaSyBGezXYAnRUwqZxQ-HWgp25Kl0ba3nJGII',
  authDomain:
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'anzura-dev.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'anzura-dev',
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
    'anzura-dev.firebasestorage.app',
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '739834675720',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);

  // Safari/WebKit blocks Firestore's streaming WebChannel fetch requests
  // ("Fetch API cannot load ... /Write/channel ... due to access control
  // checks"), which causes reads/writes to hang and fail (e.g. "Unable to add
  // user"). Force long-polling so Firestore uses standard XHR requests that
  // Safari does not block. This must be set before any Firestore access.
  firebase.firestore().settings({ experimentalForceLongPolling: true });
}

export default firebase;
